import React, { useEffect, useState } from "react";
import bizmakLogo from "../assets/img/bizmak-logo.png";

function Navigation() {
  const [solid, setSolid] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark fixed-top bizmak-nav ${
        solid ? "nav-solid" : ""
      }`}
      id="mainNav"
    >
      <div className="container">
        <a className="navbar-brand d-flex align-items-center" href="#page-top">
          <img
            src={bizmakLogo}
            alt="BizMak Inc logo"
            className="bizmak-nav-logo"
          />
          BizMak<span className="brand-accent"> Inc</span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarResponsive"
          aria-controls="navbarResponsive"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarResponsive">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item mx-0 mx-lg-1">
              <a className="nav-link py-2 px-0 px-lg-3 rounded" href="#page-top">
                Home
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a className="nav-link py-2 px-0 px-lg-3 rounded" href="#service">
                Services
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-2 px-0 px-lg-3 rounded"
                href="#portfolio"
              >
                Work
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a
                className="nav-link py-2 px-0 px-lg-3 rounded"
                href="#fedsupplier"
              >
                Government
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1">
              <a className="nav-link py-2 px-0 px-lg-3 rounded" href="#aboutus">
                About
              </a>
            </li>
            <li className="nav-item mx-0 mx-lg-1 ms-lg-2 mt-2 mt-lg-0">
              <a
                className="btn btn-bizmak-gold btn-nav-cta text-uppercase"
                href="#contact"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
